import React from "react";

export default function GoldenCone({ size = 360, className = "" }) {
  const gold = "#B89968";
  const goldDark = "#9A7E52";
  const goldLight = "#D4B989";
  return (
    <svg
      viewBox="0 0 200 280"
      width={size}
      height={size * 1.4}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Stylized golden gelato cone"
    >
      <defs>
        <linearGradient id="scoopGrad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor={goldLight} />
          <stop offset="60%" stopColor={gold} />
          <stop offset="100%" stopColor={goldDark} />
        </linearGradient>
        <linearGradient id="coneGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={gold} />
          <stop offset="100%" stopColor={goldDark} />
        </linearGradient>
      </defs>

      {/* Top scoop (largest) */}
      <circle cx="100" cy="80" r="48" fill="url(#scoopGrad)" />
      {/* Middle scoop, slightly offset */}
      <circle cx="78" cy="105" r="36" fill="url(#scoopGrad)" opacity="0.95" />
      <circle cx="122" cy="108" r="34" fill="url(#scoopGrad)" opacity="0.92" />
      {/* Bottom scoop */}
      <circle cx="100" cy="128" r="38" fill="url(#scoopGrad)" />

      {/* Highlight on top scoop */}
      <ellipse cx="86" cy="62" rx="14" ry="8" fill={goldLight} opacity="0.55" />

      {/* Cone */}
      <path
        d="M55 150 L145 150 L100 268 Z"
        fill="url(#coneGrad)"
      />
      {/* Cone waffle lines (diagonal lattice) */}
      <g stroke={goldDark} strokeWidth="1.2" opacity="0.55">
        <line x1="68" y1="170" x2="120" y2="170" />
        <line x1="74" y1="190" x2="126" y2="190" />
        <line x1="80" y1="210" x2="120" y2="210" />
        <line x1="88" y1="230" x2="112" y2="230" />
        <line x1="70" y1="155" x2="110" y2="255" />
        <line x1="90" y1="155" x2="100" y2="270" />
        <line x1="110" y1="155" x2="92" y2="265" />
        <line x1="130" y1="155" x2="90" y2="255" />
      </g>

      {/* Cone top edge */}
      <ellipse cx="100" cy="150" rx="45" ry="6" fill={gold} stroke={goldDark} strokeWidth="1.5" />

      {/* Tiny star/spark */}
      <g fill={goldLight} opacity="0.9">
        <path d="M150 40 l3 8 8 3 -8 3 -3 8 -3 -8 -8 -3 8 -3 z" />
        <path d="M40 130 l2 5 5 2 -5 2 -2 5 -2 -5 -5 -2 5 -2 z" />
      </g>
    </svg>
  );
}
